module.exports = __webpack_public_path__ + "static/media/flaglicense.40fbb883.jpg";